import React from "react";

export const Video = () => {
    return (
        <div className="mt-3">
          <iframe width="100%" height="200" src="https://www.youtube.com/embed/QfMCsLkPMKg?si=wOvSMpE6B1mEraxZ&controls=0&autoplay=1&mute=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
          {/*<iframe loading="lazy" src="https://player.vimeo.com/video/846451515?h=53f972b0f5&autoplay=1&loop=1&badge=0&color=999999&title=0&byline=0&portrait=0&background=1" title="video" width="100%" height="200" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen></iframe>*/}
        </div>
      );
}